import { createSelector } from '@ngrx/store';
import { submissionFeatureKey } from '../constants';
import { SubmissionHeaderState } from '../types';

export const getIRBPlus = createSelector(
  (state: any) => state[submissionFeatureKey],
  (submissionHeader: SubmissionHeaderState) => submissionHeader.irbState,
);
